angular.module('picmonic-common')
    .factory("SplitTest", ['$resource', function($resource){
        return $resource("/apiv2/user/split-tests/:test", {'test': '@test'}, {
            'post':{method:'POST', isArray:false}
        });
    }]);
